import type { Middleware } from "@reduxjs/toolkit";
import { isRejected, isRejectedWithValue } from "@reduxjs/toolkit";
import { trackException } from "utils/amplitudeAnalytics";

export const amplitudeExceptionMiddleware: Middleware =
  () => (next) => (action: unknown) => {
    const result = next(action);

    if (isRejectedWithValue(action)) {
      trackException(action.payload, {
        source: "redux",
        actionType: action.type,
      });
    } else if (isRejected(action)) {
      trackException(action.error, {
        source: "redux",
        actionType: action.type,
      });
    }

    return result;
  };
